// DECIMAL columns (quantity/cost/balance fields) come back from the API as
// raw strings at whatever precision they're stored at (e.g. "50.000" for a
// DECIMAL(12,3) quantity, "12.50" for a DECIMAL(12,2) cost) - this coerces
// and fixes them to a consistent 2 decimal places for display everywhere.
export function formatDecimal(value) {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (isNaN(num)) return "—";
  return num.toFixed(2);
}
